import classNames from "classnames";
import useWindowSize from "PFCore/helpers/use_window_size";
import BackIcon from "PFIcons/back_icon.svg";
import NextIcon from "PFIcons/next.svg";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";

import css from "./scrollable_badges_row.less";

const ScrollableBadgesRow = ({ values, itemClick, style, className }) => {
  const [offset, setOffset] = useState(0);
  const [rootWidth, setRootWidth] = useState();
  const [ulWidth, setUlWidth] = useState();
  const ulRef = useRef();
  const rootRef = useRef();

  const { windowWidth } = useWindowSize();

  let [prev, current, next] = getOffsets(offset, ulRef.current, rootRef.current);

  useEffect(() => {
    [prev, current, next] = getOffsets(offset, ulRef.current, rootRef.current);
  }, [offset]);

  // this effect is used to calculate width of both element and choose to show or hide the arrows
  useEffect(() => {
    rootRef.current && setRootWidth(rootRef.current.offsetWidth);
    ulRef.current && setUlWidth(ulRef.current.offsetWidth);
  }, [ulRef, rootRef, windowWidth, values]);

  const showArrows = ulWidth >= rootWidth;

  return (
    <div className={classNames(css.root, className)} style={style} ref={rootRef}>
      <ul ref={ulRef} className={css.ul} style={{ transform: `translate(-${current}px, 0)` }}>
        {values.map(({ text, id, isBeingRemoved }) => (
          <li
            key={id}
            onClick={() => itemClick(id)}
            className={classNames(css.item, {
              [css.isBeingRemoved]: isBeingRemoved,
              [css.isClickable]: !!itemClick
            })}
          >
            {text}
          </li>
        ))}
      </ul>
      {showArrows && (
        <>
          <div className={css.leftArrow}>
            <button onClick={() => setOffset(prev)} className={css.left}>
              <BackIcon width={20} height={20} />
            </button>
          </div>
          <div className={css.rightArrow}>
            <button onClick={() => setOffset(next)} className={css.right}>
              <NextIcon width={20} height={20} />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

const getOffsets = (offset, ul, root) => {
  if (!ul || !root) {
    return [0, 0, 0];
  }

  const BUTTONS_WIDTH = 70;
  const min = 0;
  const max = ul.scrollWidth - (root.offsetWidth - BUTTONS_WIDTH);

  if (max < min) {
    return [0, 0, 0];
  }

  const children = ul.children || [];
  for (let i = 0; i < children.length; i++) {
    const child = children[i];
    const { offsetLeft } = child;

    if (offset <= offsetLeft) {
      return [
        Math.min(max, children[i - 1] ? children[i - 1].offsetLeft : 0),
        Math.min(max, offsetLeft),
        Math.min(max, children[i + 1] ? children[i + 1].offsetLeft : offsetLeft)
      ];
    }
  }

  return [0, 0, 0];
};

ScrollableBadgesRow.propTypes = {
  values: PropTypes.arrayOf(
    PropTypes.shape({ text: PropTypes.string, id: PropTypes.number, isBeingRemoved: PropTypes.bool })
  ).isRequired,
  style: PropTypes.object,
  itemClick: PropTypes.func,
  className: PropTypes.string
};

export default ScrollableBadgesRow;
